import VSelectCourseTag from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseTag', VSelectCourseTag),
};
